<template>
    <div class="popup" v-show="show">
        <div class="popup-bd-wrap">
            <div class='popup-bd'>
                <p class='popup-tips'>
                    <slot></slot>
                </p>
            </div>
            <div class='popup-btn-group btn-group-line'>
                <btn type="link" @click="onCancel" v-show="cancelShow">{{cancelText}}</btn>
                <btn type="link" @click="onConfirm" v-show="confirmShow" :href="href">{{confirmText}}</btn>
            </div>
        </div>
    </div>
</template>
<script>
import Btn from './BtnPop.vue'
import storageSupport from '../../tools/storageSupport.js'
export default {
    components: {
        Btn
    },
    props: {
        href: {
            type: String,
            default: 'javascript:;'
        },
        show: {
            type: Boolean,
            default: false
        },
        cancelText: {
            type: String,
            default: '取消'
        },
        confirmText: {
            type: String,
            default: '确定'
        },
        cancelShow: {
            type: Boolean,
            default: true
        },
        confirmShow: {
            type: Boolean,
            default: true
        },
        city: {
            type: String,
            default: '北京'
        }
    },
    methods: {
        onCancel() {
            var that = this
            that.show = false
            // that.setLocal()
            that.$emit('on-cancel')
        },
        onConfirm() {
            var that = this
            that.show = false
            // that.setLocal()
            if (storageSupport) {
                localStorage.setItem('COUPON_STORAGE_CITYNAME', that.city)
            }
            that.$emit('on-confirm')
        },
        // setLocal() {
        //     var that = this
            // this.$store.dispatch('flag')
        // }
    }
}
</script>
<style scoped>
.popup {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    text-align: center;
    color: #292d33;
    font-size: 13px;
}

.popup .popup-hd {
    font-size: 17px;
    line-height: 1;
    color: #292d33;
    font-weight: normal;
    margin: 0;
}

.popup .popup-tips {
    font-size: 15px;
    line-height: 17px;
    margin: 0;
}

.popup .popup-bd-wrap {
    position: absolute;
    z-index: 1000;
    left: 50%;
    top: 50%;
    width: 275px;
    height: auto;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
    -ms-sizing: content-box;
    -o-sizing: content-box;
    box-sizing: content-box;
    background-color: #ffffff;
    border-radius: 5px;
    overflow: hidden;
}

.popup .popup-bd {
    padding: 20px 15px;
}

.popup .popup-btn-group:before {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 100%;
    height: 0.1rem;
    background-color: #e0e0e0;
    -webkit-transform: scaleY(0.5);
    -moz-transform: scaleY(0.5);
    -ms-transform: scaleY(0.5);
    -o-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0;
    -moz-transform-origin: 0;
    -ms-transform-origin: 0;
    transform-origin: 0;
    z-index: 1;
}

.popup .popup-btn-group {
    position: relative;
}

.popup .popup-btn-group:before {
    top: 0;
}

.popup .btn-custom-link:nth-child(2) {
    position: relative;
    margin-left: 0;
}

.popup .btn-custom-link:nth-child(2):before {
    position: absolute;
    top: 0;
    left: 0;
    content: '';
    width: 0.1rem;
    height: 100%;
    background-color: #e8ebf0;
    -webkit-transform: scaleX(0.5);
    -moz-transform: scaleX(0.5);
    -ms-transform: scaleX(0.5);
    -o-transform: scaleX(0.5);
    transform: scaleX(0.5);
    -webkit-transform-origin: -1px 0;
    -moz-transform-origin: -1px 0;
    -ms-transform-origin: -1px 0;
    -o-transform-origin: -1px 0;
    transform-origin: -1px 0;
}

.popup .btn-custom {
    font-size: 16px;
}

.popup .btn-custom-link:active {
    color: #e6454a;
    background: #f5f7fa;
    text-decoration: none;
}

.btn-group-line {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -moz-flex;
    display: -ms-flexbox;
    display: box;
    display: flexbox;
    display: flex;
}

.popup .slotStyle {
    display: block;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// Alert.vue?72484a9e